module.exports = __webpack_public_path__ + "img/Tiktok-blanco.fccbaf5c.svg";